import { useSelector } from 'react-redux'

import { calculateSectionScore } from '~/pages/anatomyV2/libs/calculateSectionScore'
import SectionCompleteTemplate from '~/pages/anatomyV2/libs/components/SectionCompleteTemplate'
import { SECTION_3_SCORING } from '~/pages/anatomyV2/libs/scoredSections'
import { selectAnswers } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const NEXT_SECTION_NUMBER = 4
const POINTS_GOAL =
  SECTION_3_SCORING.scoredPageIds.length * SECTION_3_SCORING.pointsPerQuestion

const Section3CompleteAnatomyV2 = (props: TPageProps) => {
  const answers = useSelector(selectAnswers)
  const pointsEarned = calculateSectionScore(SECTION_3_SCORING, answers)

  return (
    <SectionCompleteTemplate
      {...props}
      nextSectionNumber={NEXT_SECTION_NUMBER}
      titleI18nKey="onboarding.section3Complete.title"
      subtitleI18nKey="onboarding.section3Complete.subtitle"
      pointsEarned={pointsEarned}
      pointsGoal={POINTS_GOAL}
      question="Section 3 complete"
    />
  )
}

export default Section3CompleteAnatomyV2
